import React from "react";
import banner from "../../../assets/images/newpages/guide-banner.png";
const GuideBanner = () => {
  return (
    <section className="keyzi_conquer--wrapper  keyzi_embark--wrapper  keyzi_guide--wrapper">
      <div className="container">
        <div className="keyzi_conquer--inner">
          <div className="row">
            <div className="col-md-6">
              <div className="left-side">
                <h3>Choosing Your Guide</h3>
                <p>Driving Instructor
vs. Parent-Taught Lessons</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="right-side">
                <img src={banner} alt="Car" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuideBanner;
